<template>
  <div>
    <MainHeader />
    <main>
      <Breadcrumb page="Plans" />
      <Pricing />
    </main>
    <MainFooter />
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'
import MainFooter from '@/components/MainFooter.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import Pricing from '@/components/Pricing.vue'
export default {
  name: 'Plans',
  components: {
    MainHeader,
    MainFooter,
    Breadcrumb,
    Pricing,
  },
}
</script>
